import React from 'react'

function Footer() {
    const date = new Date()
    const year = date.getFullYear()
    return (
        <div className='bg-[#18191A]  text-gray-300 text-center py-8 md:text-lg text-sm tracking-wider '>
            <p>© {year} All Rights Reserved by Faijul Azim.</p>
        </div>
    )
}

export default Footer
